import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/user-management/applications/index.html';

const links: Record<string, string> = {
  users: '/infoTrac/user-management',
  roles: '/infoTrac/user-management/roles',
  apps: '/infoTrac/user-management/apps',
  edit: '/infoTrac/user-management/edit-app',
};

function UserManagementApplications() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const users = iframeDocument.getElementById('users');
      const roles = iframeDocument.getElementById('roles');
      const apps = iframeDocument.getElementById('apps');
      const edit = iframeDocument.getElementsByClassName('edit-app');

      const submit = iframeDocument.getElementById('submitBtn');

      if (users) users.addEventListener('click', () => navigate(links.users));
      if (roles) roles.addEventListener('click', () => navigate(links.roles));
      if (apps) apps.addEventListener('click', () => navigate(links.apps));

      if (submit) submit.addEventListener('click', () => navigate(links.users));

      if (edit.length) {
        for (let i = 0; i < edit.length; i++) {
          edit[i].addEventListener('click', () => navigate(links.edit));
        }
      }
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return <iframe ref={iframeRef} title="user-management-applications" src={path} width="100%" height="400px" />;
}

export default UserManagementApplications;
